import { SVGProps } from 'react';
const SvgDoubleQuotesR = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M14 8a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v4h-4a1 1 0 0 1-1-1V8ZM16 17a3 3 0 0 0 3-3v-2M5 8a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v4H6a1 1 0 0 1-1-1V8ZM7 17a3 3 0 0 0 3-3v-2"
    />
  </svg>
);
export default SvgDoubleQuotesR;
